<template>
  <div class="projectCanten">
    <el-row :gutter="10">
      <el-col :span="18">
        <div class="xmzx">
          <div class="header">
            <div class="hl">
              <div class="title">项目中心</div>
              <div class="searche">
                <el-input
                  placeholder="搜索标题和ID"
                  suffix-icon="el-icon-search"
                  v-model="filterText"
                >
                </el-input>
                <el-select
                  clearable
                  v-model="ct_status"
                  placeholder="请选择状态"
                  :disabled="!userInfo.director"
                  @change="getdata"
                >
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  clearable
                  v-model="Service_Manager"
                  placeholder="请选择经理"
                  @change="getdata"
                >
                  <el-option :label="''" :value="''" />
                  <el-option
                    v-for="item in tboptions.fzr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select
                  clearable
                  v-model="ServiceMan"
                  placeholder="请选择工程师"
                  @change="getdata"
                >
                  <el-option :label="''" :value="''" />
                  <el-option
                    v-for="item in tboptions.fzr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="hr">
              <a v-if="keyname == 'city'" @click="setKeyname('Service_Manager')"
                ><i class="el-icon-files"></i>按地区</a
              >
              <a
                v-else-if="keyname == 'Service_Manager'"
                @click="setKeyname('city')"
                ><i class="el-icon-user"></i>按经理</a
              >
            </div>
          </div>
          <div class="xmzx-b">
            <el-card class="land" v-for="(e, i) in data1" :key="i">
              <div class="local" slot="header">
                <div>
                  <i class="el-icon-location-outline"></i>{{ e.local }}
                  <span>({{ e.list.length }})</span>
                </div>
                <a @click="e.show = !e.show">
                  <i v-if="e.show" class="el-icon-caret-bottom"></i>
                  <i v-else class="el-icon-caret-top"></i
                ></a>
              </div>
              <el-row :gutter="10" class="cardbox" v-show="e.show">
                <el-col v-for="(item, ii) in e.list" :key="ii" :span="4">
                  <el-card
                    shadow="always"
                    class="proitem"
                    :body-style="{ padding: '0px' }"
                  >
                    <a @click="goto(item)">
                      <img :src="item.pic" :alt="item.name" class="image" />
                      <div class="name">
                        {{ item.name + '-' + item.ctname }}
                      </div>
                      <div class="zt" v-if="item.ct_status">
                        {{ item.ct_status }}
                      </div>
                    </a>
                  </el-card>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="title2">项目统计</div>
        <div class="gcs">
          <div class="header">
            <img
              :src="require('@/assets/img/resume_tx.png')"
              alt=""
              class="pic"
            />
            <div class="hl">
              <div class="name">{{ userInfo.name }}</div>
              <div class="job">工程师</div>
            </div>
          </div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="本一周（15）" name="first">
              <!-- <div
                class="gcslist"
                @click="goto(e)"
                v-for="(e, i) in data2"
                :key="i"
              >
                {{ e.name + '-' + e.ctname }}
              </div> -->
            </el-tab-pane>
            <el-tab-pane label="最近一个月（40）" name="second"
              ><div
                class="gcslist"
                @click="goto(e)"
                v-for="(e, i) in data3"
                :key="i"
              >
                {{ e.name + '-' + e.ctname }}
              </div></el-tab-pane
            >
          </el-tabs>
        </div>
        <div class="xmyq">
          <div class="header">
            <i class="el-icon-connection"></i>项目逾期（15）
          </div>
          <div class="ps">
            <div class="ps2">逾期率：<span> 15%</span></div>
          </div>
          <div class="body">
            <div
              class="gcslist"
              @click="goto(e)"
              v-for="(e, i) in data2"
              :key="i"
            >
              {{ e.title + '['+e.yjdate+']'  }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { GetProject, GetFZRlist } from '@api/api.js'
export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {}, // 用户登录信息
      filterText: '',
      Service_Manager: '',
      ServiceMan: '',
      activeName: 'first',
      ini: [], // 原始数据-加工city
      ini2: [], // 原始数据
      data1: [],
      data2: [],
      data3: [],
      keyname: 'city',
      status: [
        { label: '未结案', value: '未结案' },
        { label: '已结案', value: '已结案' },
        { label: '所有', value: '所有' }
      ],
      ct_status: '未结案',
      tboptions: {
        fzr: []
      }
    }
  },
  created() {
    this._GetProject()
    this._GetProject()
    this._GetFZRlist()
  },
  watch: {
    filterText(val) {
      this.getdata()
    },
    Service_Manager(val) {
      this.getdata()
    },
    ServiceMan(val) {
      this.getdata()
    }
  },
  methods: {
    _GetProject() {
      GetProject({
        name: this.userInfo.name
      }).then(res => {
        this.data2 = res.list2.map(e=>{
          if(e.yjdate.indexOf('T')>-1)
            e.yjdate = e.yjdate.split('T')[0]
            return e
        })
        this.data3 = res.list
        this.ini2 = res.list
        this.getdata()
      })
    },
    _GetFZRlist() {
      GetFZRlist().then(res => {
        this.tboptions.fzr = res.list.map(e => {
          return {
            value: e.empname,
            label: e.empname
          }
        })
      })
    },
    setKeyname(k) {
      this.keyname = k
      this.getdata()
    },
    getdata() {
      let data = [],
        local = []
      this.ini2
        .filter(e => {
          if (this.ct_status == '所有') return true
          else if (this.ct_status == '未结案') {
            return e.ct_status != '已结案'
          } else if (this.ct_status == '已结案') {
            return e.ct_status == '已结案'
          }
        })
        .filter(e => {
          if (this.filterText)
            return (
              e.name.indexOf(this.filterText) > -1 ||
              e.ctname.indexOf(this.filterText) > -1 ||
              e.ServiceMan.indexOf(this.filterText) > -1 ||
              (e.ServiceMan2 && e.ServiceMan2.indexOf(this.filterText) > -1) ||
              (e.ServiceMan3 && e.ServiceMan3.indexOf(this.filterText) > -1) ||
              e.Saler.indexOf(this.filterText) > -1 ||
              e.Service_Manager.indexOf(this.filterText) > -1
            )
          else {
            return true
          }
        })
        .filter(e => {
          if (this.ServiceMan && this.Service_Manager) {
            return (
              e.Service_Manager.indexOf(this.Service_Manager) > -1 ||
              e.ServiceMan.indexOf(this.ServiceMan) > -1 ||
                (e.ServiceMan2 &&
                  e.ServiceMan2.indexOf(this.ServiceMan) > -1) ||
                (e.ServiceMan3 && e.ServiceMan3.indexOf(this.ServiceMan) > -1)
            )
          } else if (this.Service_Manager)
            return e.Service_Manager.indexOf(this.Service_Manager) > -1
          else if (this.ServiceMan)
            return (
              e.ServiceMan.indexOf(this.ServiceMan) > -1 ||
              (e.ServiceMan2 && e.ServiceMan2.indexOf(this.ServiceMan) > -1) ||
              (e.ServiceMan3 && e.ServiceMan3.indexOf(this.ServiceMan) > -1)
            )
          else {
            return true
          }
        })
        .forEach(e => {
          e.pic = require('@/assets/img/pro1.png')
          if (local.indexOf(e[this.keyname]) == -1) {
            local.push(e[this.keyname])
            data.push({
              show: true,
              local: e[this.keyname],
              list: [e]
            })
          } else {
            data[local.indexOf(e[this.keyname])].list.push(e)
          }
        })
      this.ini = data
      this.data1 = JSON.parse(JSON.stringify(this.ini))
    },
    goto(item) {
      let path = '/main/project/pre'
      let query = {
        autoid: item.autoid,
        cbd: item.cbd,
        ced: item.yj_jadate || item.ced,
        name: item.name + '-' + item.ctname
      }
      this.$router.push({ path: path, query: query })
    }
  }
}
</script>

<style scoped lang="scss">
.projectCanten {
  .el-row {
    // margin: 10px;
    padding: 10px;
    width: calc(100% - 20px);

    .xmzx {
      background: #fff;
      border-radius: 10px;
      height: 1070px;
      overflow-y: auto;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 10px;
        .hl {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 20px;
            font-weight: bold;
            width: 100px;
            flex: 2;
          }
          .searche {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .hr {
          color: #999;
          font-size: 16px;
          a {
            cursor: pointer;
          }
        }
      }
      .xmzx-b {
        padding: 0 10px;
        .land {
          width: 100%;
          .local {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ccc;
            font-size: 20px;
            font-weight: bold;
            i {
              color: #999;
            }
            span {
              color: red;
            }
            .el-icon-location-outline {
              margin-right: 10px;
            }
          }
          .cardbox {
            .el-card {
              height: 180px;
              margin: 10px 0;
              cursor: pointer;
              position: relative;
              .image {
                width: 100%;
                height: 120px;
              }
              .name {
                font-size: 18px;
                font-weight: 500;
                padding: 10px;
              }
              .zt {
                position: absolute;
                left: 5px;
                top: 5px;
              }
            }
          }
        }
      }
    }

    .title2 {
      font-size: 20px;
      font-weight: bold;
    }
    .gcs {
      background: #fff;
      border-radius: 10px;
      margin: 10px 0;
      .header {
        height: 80px;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 10px;
        color: #fff;
        background: url('~@/assets/img/pic_kb_01.png') right center no-repeat
          #0090ff;
        .pic {
          width: 60px;
          margin-right: 10px;
        }
        .hl {
          .name {
            font-size: 20px;
            font-weight: bold;
          }
        }
      }
      .el-tabs {
        padding: 10px;

        .el-tab-pane {
          height: 370px;
          overflow-y: auto;
          .gcslist {
            cursor: pointer;
            line-height: 40px;
            font-size: 18px;
            border-bottom: 1px solid #ccc;
          }
        }
      }
    }
    .xmyq {
      background: #fff;
      border-radius: 10px;
      margin: 10px 0;
      padding: 10px;
      .header {
        font-size: 20px;
        font-weight: bold;
        color: #d70a0a;
      }
      .ps {
        height: 60px;
        background: linear-gradient(90deg, #f6d1d1 0%, #fff0f0 65%);

        border-radius: 30px;
        margin: 10px 0;
        .ps2 {
          background: url('~@/assets/img/pic_kb_02.png') 20px center/ 80px 40px
            no-repeat;
          height: 60px;
          color: #bb0007;
          text-align: right;
          padding: 0 10px;
          font-weight: 400;
          padding-top: 25px;
          span {
            font-size: 2em;
            font-weight: bold;
          }
        }
      }
      .body {
        height: 370px;
        overflow-y: auto;
        .gcslist {
          cursor: pointer;
          line-height: 40px;
          font-size: 18px;
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
}
</style>
